import React from "react";
import {
  Breadcrumb,
  Persona,
  PersonaSize,
  ActionButton,
} from "@fluentui/react";
import { useHistory, useLocation } from "react-router-dom";
import igradLogo from "../images/igrad-demo-logo.png";
import { useAccount, useMsal } from "@azure/msal-react";

function _getCustomDivider() {
  return <span aria-hidden="true">/</span>;
}

const Header = () => {
  let history = useHistory();
  let { pathname } = useLocation();

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  function handleBreadCrumbClick(pathClicked, pathArray) {
    const indexOfPathClicked = pathArray.indexOf(pathClicked);
    const splicedPathArray = pathArray.splice(0, indexOfPathClicked + 1);
    return history.push(splicedPathArray.join("/"));
  }

  function createBreadCrumbs() {
    if (pathname !== "/") {
      const paths = pathname.split("/");
      if (Array.isArray(paths)) {
        return paths.map((path) => ({
          text: path,
          key: path,
          onClick: () => handleBreadCrumbClick(path, paths),
        }));
      }
    }
  }
  const breadcrumbs = createBreadCrumbs();
  return (
    <div className="admin-header">
      <span className="logo">
        <img src={igradLogo} alt={"logo"} />
      </span>
      <div className="breadcrumbs">
        <Breadcrumb
          items={breadcrumbs}
          maxDisplayedItems={6}
          dividerAs={_getCustomDivider}
          overflowAriaLabel="More links"
        />
      </div>

      <ActionButton
        onClick={() => instance.logout()}
        className="action-button"
        iconProps={{ iconName: "SignOut" }}
        allowDisabledFocus
      >
        Log Out
      </ActionButton>
      <Persona text={account && account.name} size={PersonaSize.size32} />
      <hr />
    </div>
  );
};

export default Header;
